import React from "react";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as categoryRedux from "modules/Category/_redux/categoryRedux";
import { formatThousandsDot } from "helpers/FormatNumbersWithComma";
import "./sahibindenFilters.css";

// Sahibinden tarzı km aralığı: sade min/max input.
// selectedFilter.minMaxKm = [min, max]; backend plugin'i km field'ı üzerinde
// { $gte, $lte } ile uygular.
function SLMinMaxKm(props) {
  const { selectedFilter } = useSelector(
    (state) => ({ selectedFilter: state.category.selectedFilter }),
    shallowEqual
  );

  const value = selectedFilter?.minMaxKm || ["", ""];
  const [min, max] = value;

  const setRange = (nextMin, nextMax) => {
    const empty =
      (nextMin === "" || nextMin === null || nextMin === undefined) &&
      (nextMax === "" || nextMax === null || nextMax === undefined);
    if (empty) {
      props.removeFilter({ parent: "minMaxKm" });
      return;
    }
    props.addFilterBulk({ parent: "minMaxKm", value: [nextMin, nextMax] });
  };

  const toNumber = (raw) => {
    const digits = raw.replace(/\D/g, "");
    return digits === "" ? "" : Number(digits);
  };

  return (
    <section id={props.filter.id} className="sf-section">
      <div className="sf-title">{props.filter.title || "Kilometre"}</div>
      <div className="sf-minmax">
        <input
          className="sf-input"
          type="text"
          inputMode="numeric"
          placeholder="min"
          value={formatThousandsDot(min)}
          onChange={(e) => setRange(toNumber(e.target.value), max)}
        />
        <span className="sf-dash">–</span>
        <input
          className="sf-input"
          type="text"
          inputMode="numeric"
          placeholder="max"
          value={formatThousandsDot(max)}
          onChange={(e) => setRange(min, toNumber(e.target.value))}
        />
      </div>
    </section>
  );
}

export default connect(null, { ...categoryRedux.actions })(SLMinMaxKm);
